/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSharedApp = /* GraphQL */ `
  mutation CreateSharedApp(
    $input: CreateSharedAppInput!
    $condition: ModelSharedAppConditionInput
  ) {
    createSharedApp(input: $input, condition: $condition) {
      id
      clientId
      status
      partnerName
      offerId
      offerName
      dealerFee
      channel
      category
      loanAmount
      paymentAmount
      calculatorType
      integratorId
      redirectUrl
      states
      offers
      submittingUser {
        email
        firstName
        lastName
        phone
        __typename
      }
      sendEmail
      displayIframe
      referenceId
      formUrl
      partnerWebsiteUrl
      bundleClientId
      singleOfferLinks
      parentOrganizationClientId
      organizationId
      useConnectedOrgs
      payments {
        shareMethods {
          email
          sms
          online
        }
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSharedApp = /* GraphQL */ `
  mutation UpdateSharedApp(
    $input: UpdateSharedAppInput!
    $condition: ModelSharedAppConditionInput
  ) {
    updateSharedApp(input: $input, condition: $condition) {
      id
      clientId
      status
      partnerName
      offerId
      offerName
      dealerFee
      channel
      category
      loanAmount
      paymentAmount
      calculatorType
      integratorId
      redirectUrl
      states
      offers
      submittingUser {
        email
        firstName
        lastName
        phone
        __typename
      }
      sendEmail
      displayIframe
      referenceId
      formUrl
      partnerWebsiteUrl
      bundleClientId
      singleOfferLinks
      parentOrganizationClientId
      organizationId
      useConnectedOrgs
      payments {
        shareMethods {
          email
          sms
          online
        }
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSharedApp = /* GraphQL */ `
  mutation DeleteSharedApp(
    $input: DeleteSharedAppInput!
    $condition: ModelSharedAppConditionInput
  ) {
    deleteSharedApp(input: $input, condition: $condition) {
      id
      clientId
      status
      partnerName
      offerId
      offerName
      dealerFee
      channel
      category
      loanAmount
      paymentAmount
      calculatorType
      integratorId
      redirectUrl
      states
      offers
      submittingUser {
        email
        firstName
        lastName
        phone
        __typename
      }
      sendEmail
      displayIframe
      referenceId
      formUrl
      partnerWebsiteUrl
      bundleClientId
      singleOfferLinks
      parentOrganizationClientId
      organizationId
      useConnectedOrgs
      payments {
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGoodLinks = /* GraphQL */ `
  mutation CreateGoodLinks(
    $input: CreateGoodLinksInput!
    $condition: ModelGoodLinksConditionInput
  ) {
    createGoodLinks(input: $input, condition: $condition) {
      id
      clientId
      custFirstName
      custLastName
      custEmail
      custMobile
      custState
      custLoanAmount
      offerId
      emailSent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGoodLinks = /* GraphQL */ `
  mutation UpdateGoodLinks(
    $input: UpdateGoodLinksInput!
    $condition: ModelGoodLinksConditionInput
  ) {
    updateGoodLinks(input: $input, condition: $condition) {
      id
      clientId
      custFirstName
      custLastName
      custEmail
      custMobile
      custState
      custLoanAmount
      offerId
      emailSent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGoodLinks = /* GraphQL */ `
  mutation DeleteGoodLinks(
    $input: DeleteGoodLinksInput!
    $condition: ModelGoodLinksConditionInput
  ) {
    deleteGoodLinks(input: $input, condition: $condition) {
      id
      clientId
      custFirstName
      custLastName
      custEmail
      custMobile
      custState
      custLoanAmount
      offerId
      emailSent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRequests = /* GraphQL */ `
  mutation CreateRequests(
    $input: CreateRequestsInput!
    $condition: ModelRequestsConditionInput
  ) {
    createRequests(input: $input, condition: $condition) {
      id
      accountName
      clientId
      status
      salesforce
      salesforceId
      offer
      offersRequested
      states
      channel
      category
      loanAmount
      paymentAmount
      calculatorType
      integratorId
      redirectUrl
      submittingUser {
        email
        firstName
        lastName
        phone
        __typename
      }
      sendEmail
      referenceId
      contactEmail
      partnerEmail
      accountOwnerEmail
      apiKeys
      notes
      requestNotes
      bundleClientId
      singleOfferLinks
      parentOrganizationClientId
      organizationId
      useConnectedOrgs
      payments {
        shareMethods {
          email
          sms
          online
        }
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRequests = /* GraphQL */ `
  mutation UpdateRequests(
    $input: UpdateRequestsInput!
    $condition: ModelRequestsConditionInput
  ) {
    updateRequests(input: $input, condition: $condition) {
      id
      accountName
      clientId
      status
      salesforce
      salesforceId
      offer
      offersRequested
      states
      channel
      category
      loanAmount
      paymentAmount
      calculatorType
      integratorId
      redirectUrl
      submittingUser {
        email
        firstName
        lastName
        phone
        __typename
      }
      sendEmail
      referenceId
      contactEmail
      partnerEmail
      accountOwnerEmail
      apiKeys
      notes
      requestNotes
      bundleClientId
      singleOfferLinks
      parentOrganizationClientId
      organizationId
      useConnectedOrgs
      payments {
        shareMethods {
          email
          sms
          online
        }
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRequests = /* GraphQL */ `
  mutation DeleteRequests(
    $input: DeleteRequestsInput!
    $condition: ModelRequestsConditionInput
  ) {
    deleteRequests(input: $input, condition: $condition) {
      id
      accountName
      clientId
      status
      salesforce
      salesforceId
      offer
      offersRequested
      states
      channel
      category
      loanAmount
      paymentAmount
      calculatorType
      integratorId
      redirectUrl
      submittingUser {
        email
        firstName
        lastName
        phone
        __typename
      }
      sendEmail
      referenceId
      contactEmail
      partnerEmail
      accountOwnerEmail
      apiKeys
      notes
      requestNotes
      bundleClientId
      singleOfferLinks
      parentOrganizationClientId
      organizationId
      useConnectedOrgs
      payments {
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAdminErrorLog = /* GraphQL */ `
  mutation CreateAdminErrorLog(
    $input: CreateAdminErrorLogInput!
    $condition: ModelAdminErrorLogConditionInput
  ) {
    createAdminErrorLog(input: $input, condition: $condition) {
      id
      sharedAppId
      requestId
      error
      formUrl
      clientId
      integrator
      organizationId
      initiative
      requesterEmail
      partnerPrimaryContactEmail
      salesforceAccountOwnerEmail
      salesforceId
      salesforceUrl
      accountName
      slackChannelRoute
      notifySlack
      notifyEmail
      emailTemplateId
      resolutionStatus
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAdminErrorLog = /* GraphQL */ `
  mutation UpdateAdminErrorLog(
    $input: UpdateAdminErrorLogInput!
    $condition: ModelAdminErrorLogConditionInput
  ) {
    updateAdminErrorLog(input: $input, condition: $condition) {
      id
      sharedAppId
      requestId
      error
      formUrl
      clientId
      integrator
      organizationId
      initiative
      requesterEmail
      partnerPrimaryContactEmail
      salesforceAccountOwnerEmail
      salesforceId
      salesforceUrl
      accountName
      slackChannelRoute
      notifySlack
      notifyEmail
      emailTemplateId
      resolutionStatus
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAdminErrorLog = /* GraphQL */ `
  mutation DeleteAdminErrorLog(
    $input: DeleteAdminErrorLogInput!
    $condition: ModelAdminErrorLogConditionInput
  ) {
    deleteAdminErrorLog(input: $input, condition: $condition) {
      id
      sharedAppId
      requestId
      error
      formUrl
      clientId
      integrator
      organizationId
      initiative
      requesterEmail
      partnerPrimaryContactEmail
      salesforceAccountOwnerEmail
      salesforceId
      salesforceUrl
      accountName
      slackChannelRoute
      notifySlack
      notifyEmail
      emailTemplateId
      resolutionStatus
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAdminErrorEmailSend = /* GraphQL */ `
  mutation CreateAdminErrorEmailSend(
    $input: CreateAdminErrorEmailSendInput!
    $condition: ModelAdminErrorEmailSendConditionInput
  ) {
    createAdminErrorEmailSend(input: $input, condition: $condition) {
      id
      adminErrorLogId
      clientId
      emailTemplateId
      toEmails
      ccEmails
      mode
      source
      sesMessageId
      subject
      sentAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAdminErrorEmailSend = /* GraphQL */ `
  mutation UpdateAdminErrorEmailSend(
    $input: UpdateAdminErrorEmailSendInput!
    $condition: ModelAdminErrorEmailSendConditionInput
  ) {
    updateAdminErrorEmailSend(input: $input, condition: $condition) {
      id
      adminErrorLogId
      clientId
      emailTemplateId
      toEmails
      ccEmails
      mode
      source
      sesMessageId
      subject
      sentAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAdminErrorEmailSend = /* GraphQL */ `
  mutation DeleteAdminErrorEmailSend(
    $input: DeleteAdminErrorEmailSendInput!
    $condition: ModelAdminErrorEmailSendConditionInput
  ) {
    deleteAdminErrorEmailSend(input: $input, condition: $condition) {
      id
      adminErrorLogId
      clientId
      emailTemplateId
      toEmails
      ccEmails
      mode
      source
      sesMessageId
      subject
      sentAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
